import { all, fork } from 'redux-saga/effects';
import user from 'redux/modules/user/sagas';

export default function* rootSaga() {
  yield all([fork(user)]);
}
